import { SpringRef, SpringValue } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';

export interface IUseSwipeArgs {
  y: SpringValue<number>;
  api: SpringRef<{ y: number }>;
  maxHeight: number;
  halfScreen?: boolean;

  close(promiseRes?: (val: unknown) => void): void;

  open(arg: { canceled?: boolean }): void;
  toggleFullscreen(): void;
}

export const useSwipe = ({ y, api, maxHeight, close, open, halfScreen, toggleFullscreen }: IUseSwipeArgs) => {
  const bind = useDrag(
    ({ last, velocity: [, vy], direction: [, dy], movement: [, my], cancel, canceled }) => {
      if (halfScreen) {
        if (my < -10) {
          toggleFullscreen();
          cancel();
        }
      } else {
        if (my < -70) {
          cancel();
        }
      }

      if (last) {
        if (my > maxHeight * 0.5 || (vy > 0.5 && dy > 0)) {
          close();
        } else {
          open({ canceled });
        }
      } else {
        api.start({ y: my, immediate: true });
      }
    },
    {
      from: () => [0, y.get()],
      filterTaps: true,
      bounds: { top: 0 },
      rubberband: true,
    },
  );

  return { y, api, open, close, bind };
};
